export const CONTRACEPTION_PROFILES = {
    combined_pill: {
        category: 'combined_pill',
        hormonalType: 'combined',
        label: 'Combined Pill',
        suppressesOvulation: true,
        hasWithdrawalBleed: true,
        expectedSpottingPattern: 'common_initial',
        spottingResolutionMonths: 3,
        adaptationPeriodMonths: 3,
        hasCyclicalPattern: true,
        typicalCycleLength: 28,
        typicalWithdrawalBleedDays: 4,
        fertileWindowRelevant: false,
        bleedingLabel: 'Withdrawal bleed',
        cycleLabel: 'Pack day',
        clinicalNotes: [
            'Breakthrough spotting is common in the first 3 months and usually resolves.',
            'Missing pills increases spotting risk and may reduce effectiveness.',
            'The bleeding during placebo week is a withdrawal bleed, not a true period.',
        ],
    },
    progestin_pill: {
        category: 'progestin_pill',
        hormonalType: 'progestin_only',
        label: 'Mini-Pill',
        suppressesOvulation: false, // inconsistent suppression
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'common_ongoing',
        spottingResolutionMonths: null,
        adaptationPeriodMonths: 6,
        hasCyclicalPattern: false,
        typicalCycleLength: null,
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: true, // ovulation not reliably suppressed
        bleedingLabel: 'Bleeding',
        cycleLabel: 'Days on method',
        clinicalNotes: [
            'Irregular bleeding is normal and may not resolve — this is the most common side effect.',
            'Must be taken within the same 3-hour window daily for effectiveness.',
            'Ovulation is not always suppressed, so some natural cycle patterns may persist.',
        ],
    },
    hormonal_iud: {
        category: 'hormonal_iud',
        hormonalType: 'progestin_only',
        label: 'Hormonal IUD',
        suppressesOvulation: false,
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'common_initial',
        spottingResolutionMonths: 6,
        adaptationPeriodMonths: 6,
        hasCyclicalPattern: false,
        typicalCycleLength: null,
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: false,
        bleedingLabel: 'Bleeding',
        cycleLabel: 'Days on method',
        clinicalNotes: [
            'Spotting and irregular bleeding are very common in the first 3-6 months.',
            'Many users experience significantly lighter periods or no periods by 6-12 months.',
            'About 20% of users stop having periods within the first year.',
        ],
    },
    copper_iud: {
        category: 'copper_iud',
        hormonalType: 'non_hormonal',
        label: 'Copper IUD',
        suppressesOvulation: false,
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'common_initial',
        spottingResolutionMonths: 3,
        adaptationPeriodMonths: 6,
        hasCyclicalPattern: true,
        typicalCycleLength: null, // natural cycle preserved
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: true,
        bleedingLabel: 'Period',
        cycleLabel: 'Cycle day',
        clinicalNotes: [
            'Periods may be heavier and crampier, especially in the first 3-6 months.',
            'Your natural cycle continues — ovulation and fertile windows still apply.',
            'Spotting between periods is common initially but usually improves.',
        ],
    },
    implant: {
        category: 'implant',
        hormonalType: 'progestin_only',
        label: 'Implant',
        suppressesOvulation: true,
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'variable',
        spottingResolutionMonths: null,
        adaptationPeriodMonths: 12,
        hasCyclicalPattern: false,
        typicalCycleLength: null,
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: false,
        bleedingLabel: 'Bleeding',
        cycleLabel: 'Days on method',
        clinicalNotes: [
            'Bleeding patterns are the most unpredictable of any method — this is normal.',
            'About 1 in 5 users stop having periods. Others may have irregular or prolonged spotting.',
            'Irregular bleeding is the #1 reason for early removal.',
            'Bleeding patterns in the first 3 months often predict the long-term pattern.',
        ],
    },
    injection: {
        category: 'injection',
        hormonalType: 'progestin_only',
        label: 'Injection',
        suppressesOvulation: true,
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'common_initial',
        spottingResolutionMonths: 9,
        adaptationPeriodMonths: 12,
        hasCyclicalPattern: false,
        typicalCycleLength: null,
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: false,
        bleedingLabel: 'Bleeding',
        cycleLabel: 'Days on method',
        clinicalNotes: [
            'Irregular bleeding and spotting are common in the first 6-12 months.',
            'Most users stop having periods after 12 months of use.',
            'After stopping, it can take 6-12 months for natural cycles to return.',
        ],
    },
    patch: {
        category: 'patch',
        hormonalType: 'combined',
        label: 'Patch',
        suppressesOvulation: true,
        hasWithdrawalBleed: true,
        expectedSpottingPattern: 'common_initial',
        spottingResolutionMonths: 3,
        adaptationPeriodMonths: 3,
        hasCyclicalPattern: true,
        typicalCycleLength: 28,
        typicalWithdrawalBleedDays: 4,
        fertileWindowRelevant: false,
        bleedingLabel: 'Withdrawal bleed',
        cycleLabel: 'Patch week',
        clinicalNotes: [
            'Works on a 4-week cycle: 3 weeks on, 1 week off (or with a placebo patch).',
            'Breakthrough spotting is common in the first 1-2 months.',
            'Bleeding during the patch-free week is a withdrawal bleed, not a true period.',
        ],
    },
    ring: {
        category: 'ring',
        hormonalType: 'combined',
        label: 'Ring',
        suppressesOvulation: true,
        hasWithdrawalBleed: true,
        expectedSpottingPattern: 'common_initial',
        spottingResolutionMonths: 3,
        adaptationPeriodMonths: 3,
        hasCyclicalPattern: true,
        typicalCycleLength: 28,
        typicalWithdrawalBleedDays: 4,
        fertileWindowRelevant: false,
        bleedingLabel: 'Withdrawal bleed',
        cycleLabel: 'Ring day',
        clinicalNotes: [
            'Works on a 4-week cycle: 3 weeks in, 1 week out.',
            'Bleeding during the ring-free week is a withdrawal bleed, not a true period.',
            'Less breakthrough spotting than the pill for most users.',
        ],
    },
    none: {
        category: 'none',
        hormonalType: 'non_hormonal',
        label: 'No Contraception',
        suppressesOvulation: false,
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'none',
        spottingResolutionMonths: null,
        adaptationPeriodMonths: 0,
        hasCyclicalPattern: true,
        typicalCycleLength: null,
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: true,
        bleedingLabel: 'Period',
        cycleLabel: 'Cycle day',
        clinicalNotes: [],
    },
    other: {
        category: 'other',
        hormonalType: 'unknown',
        label: 'Other',
        suppressesOvulation: false,
        hasWithdrawalBleed: false,
        expectedSpottingPattern: 'none',
        spottingResolutionMonths: null,
        adaptationPeriodMonths: 0,
        hasCyclicalPattern: true,
        typicalCycleLength: null,
        typicalWithdrawalBleedDays: null,
        fertileWindowRelevant: true,
        bleedingLabel: 'Period',
        cycleLabel: 'Cycle day',
        clinicalNotes: [],
    },
};
/** User-facing categories shown in the setup flow. */
export const CONTRACEPTION_CATEGORIES = [
    { key: 'combined_pill', label: 'Pill (combined)', icon: '💊' },
    { key: 'progestin_pill', label: 'Pill (mini/progestin)', icon: '💊' },
    { key: 'hormonal_iud', label: 'Hormonal IUD', icon: '🔵' },
    { key: 'copper_iud', label: 'Copper IUD', icon: '🟤' },
    { key: 'implant', label: 'Implant', icon: '📍' },
    { key: 'injection', label: 'Shot/Injection', icon: '💉' },
    { key: 'patch', label: 'Patch', icon: '🩹' },
    { key: 'ring', label: 'Ring', icon: '⭕' },
    { key: 'none', label: 'None', icon: '✖️' },
    { key: 'other', label: 'Other', icon: '❓' },
];
/** Common brands per category for the brand picker. */
export const CONTRACEPTION_BRANDS = {
    combined_pill: [
        { name: 'Yaz', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Yasmin', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Lo Loestrin Fe', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Ortho Tri-Cyclen', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Tri-Sprintec', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Levlen', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Alesse', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Beyaz', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Seasonique', category: 'combined_pill', hormonalType: 'combined' },
        { name: 'Nikki', category: 'combined_pill', hormonalType: 'combined' },
    ],
    progestin_pill: [
        { name: 'Camila', category: 'progestin_pill', hormonalType: 'progestin_only' },
        { name: 'Errin', category: 'progestin_pill', hormonalType: 'progestin_only' },
        { name: 'Nora-BE', category: 'progestin_pill', hormonalType: 'progestin_only' },
        { name: 'Slynd', category: 'progestin_pill', hormonalType: 'progestin_only' },
        { name: 'Norethindrone', category: 'progestin_pill', hormonalType: 'progestin_only' },
    ],
    hormonal_iud: [
        { name: 'Mirena', category: 'hormonal_iud', hormonalType: 'progestin_only' },
        { name: 'Kyleena', category: 'hormonal_iud', hormonalType: 'progestin_only' },
        { name: 'Liletta', category: 'hormonal_iud', hormonalType: 'progestin_only' },
        { name: 'Skyla', category: 'hormonal_iud', hormonalType: 'progestin_only' },
    ],
    copper_iud: [
        { name: 'Paragard', category: 'copper_iud', hormonalType: 'non_hormonal' },
    ],
    implant: [
        { name: 'Nexplanon', category: 'implant', hormonalType: 'progestin_only' },
        { name: 'Implanon', category: 'implant', hormonalType: 'progestin_only' },
    ],
    injection: [
        { name: 'Depo-Provera', category: 'injection', hormonalType: 'progestin_only' },
        { name: 'Depo-subQ Provera', category: 'injection', hormonalType: 'progestin_only' },
    ],
    patch: [
        { name: 'Xulane', category: 'patch', hormonalType: 'combined' },
        { name: 'Twirla', category: 'patch', hormonalType: 'combined' },
    ],
    ring: [
        { name: 'NuvaRing', category: 'ring', hormonalType: 'combined' },
        { name: 'Annovera', category: 'ring', hormonalType: 'combined' },
    ],
    none: [],
    other: [],
};
/** Look up the clinical profile for a contraception category. */
export function getContraceptionProfile(category) {
    return CONTRACEPTION_PROFILES[category];
}
/** Check if a contraception method is hormonal. */
export function isHormonalContraception(category) {
    const profile = CONTRACEPTION_PROFILES[category];
    return profile.hormonalType !== 'non_hormonal' && profile.hormonalType !== 'unknown';
}
/** Check if the user is still in the adaptation period for their method. */
export function isInAdaptationPeriod(category, startDate) {
    if (!startDate)
        return false;
    const profile = CONTRACEPTION_PROFILES[category];
    if (profile.adaptationPeriodMonths === 0)
        return false;
    const start = new Date(startDate + 'T00:00:00');
    const now = new Date();
    const monthsElapsed = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
    return monthsElapsed < profile.adaptationPeriodMonths;
}
